// eslint-disable-next-line
import store from '@/store'
import Vue from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import i18n from '@/assets/i18n/translate-message';
import { CookieUtil } from '@/helpers/cookie-util';

Vue.prototype.HOST_PROXY_ADMIN = '';

export const AppToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IkF0aGVuYSIsInNpZCI6MTYzNjc3NzI1NzgyNTkyfQ.3QLTPVKsk2Mp3j_aQ3X8bQW1wCJMNWeCkL6VPoK352c';

function AxiosFactory() {
  // 创建axios实例
  const BASE_DOMAIN = '';
  const staticAppToken = AppToken
  const axiosInstance = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: `${BASE_DOMAIN}`,
    headers: {
      'Content-Type': 'application/json', // x-www-form-urlencoded
    },
    timeout: 25000,
  });
  const BASE_VIEWS_URL = window.location.origin;

  // 添加请求拦截器
  // 需要添加proxyToken的场景
  axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = token;
      config.headers['digi-middleware-auth-user'] = token;
      config.headers.routerKey = CookieUtil.get('routerKey');
    }
    let { url } = config;
    if (url.includes('iam') || url.includes('eoc')) {
      const remoteAppToken = JSON.parse(localStorage.getItem('config'))?.appToken;
      config.headers['digi-middleware-auth-app'] = remoteAppToken ?? staticAppToken;
    }

    // get参数编码
    if (config.method === 'get' && config.params) {
      url += '?'
      const keys = Object.keys(config.params)
      // eslint-disable-next-line no-restricted-syntax
      for (const key of keys) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url;
      //
    }
    return config;
  }, error => Promise.reject(error));

  // 添加响应拦截器
  axiosInstance.interceptors.response.use((response) => {
    // 用户未登陆 或者 用户被禁用，重定向到登录页面
    if (response.data.code === '') {
      // eslint-disable-next-line
      window.location.href = `${BASE_VIEWS_URL}/login`;
    }
    // 返回结果code编码不为0时，显示错误信息
    if (response.data.code > 0) {
      return Promise.reject(response.data.message);
    }
    return response;
  }, (error) => {
    let str = '网络错误，请稍后再试';
    if (error.response.status) {
      const errorMessage = error.response.data?.errorMessage;
      switch (error.response.status) {
        case 401:
          str = errorMessage || i18n.t('dj-您的登录验证已过期，请重新登录');
          message.error(str);
          localStorage.removeItem('userName');
          CookieUtil.set('routerKey', '')
          setTimeout(() => {
            window.location.href = `${BASE_VIEWS_URL}/login`;
          }, 500)
          break;
        case 400:
          str = errorMessage || i18n.t('dj-请求失败');
          message.error(str);
          if (error.response.data?.errorCode === '10904') {
            localStorage.removeItem('userName');
            CookieUtil.set('routerKey', '')
            setTimeout(() => {
              window.location.href = `${BASE_VIEWS_URL}/login`;
            }, 500)
          }
          break;
        case 404:
          str = errorMessage || i18n.t('dj-请求错误，资源未找到');
          message.error(str);
          break;
        default:
          str = errorMessage || i18n.t('dj-请求失败');
          message.error(str);
      }
    } else {
      str = i18n.t('dj-请求失败');
      message.error(str);
    }

    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      ...error,
      str,
    });
  });
  return axiosInstance;
}

// 创建 API 实例
const createAPI = (url, method, config = {}, baseURL) => {
  const mtd = method.toLowerCase();
  const factoryInstance = new AxiosFactory(baseURL);
  if (mtd === 'post') return factoryInstance.post(url, config);
  if (mtd === 'get') {
    return factoryInstance.get(url, {
      params: config,
    });
  }
  if (mtd === 'delete') {
    return factoryInstance.delete(url, {
      params: config,
    });
  }
  return factoryInstance[mtd](url, config);
};

export default createAPI;
